import { render, staticRenderFns } from "./reserve-toast.vue?vue&type=template&id=32401a10&scoped=true&"
import script from "./reserve-toast.vue?vue&type=script&lang=js&"
export * from "./reserve-toast.vue?vue&type=script&lang=js&"
import style0 from "./reserve-toast.vue?vue&type=style&index=0&id=32401a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32401a10",
  null
  
)

export default component.exports